<template>
    <div class="contr" id="wrp">
        <div class="__wrapper">
            <div class="half first">
                <div class="__head">
                   <img :src="$fullUrl('images/profiles/'+user.profile)">
                   <h2>{{user.names | validate }}</h2>
                   <span>{{user.job | validate }}</span>
                </div>
            </div>
            <div class="half">
                <div class="profile-box">
                    <div class="right-box box">
                        <div class="location">{{user.location | validate }}</div>
                        <div class="__infos">
                            <span>{{user.phone | validate }}</span>
                            <span>|</span>
                            <span>{{user.email | validate }}</span>
                        </div>
                        <div class="cover-letter">
                            <p v-html="user.description"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="__wrapper second">
            <div class="__head">
                    <div class="person-card">
                        <img :src="$fullUrl('images/profiles/'+user.profile)">
                        <div class="info-text">
                            <h2>{{user.names | validate }}</h2>
                            <span>{{user.job | validate }}</span>
                        </div>
                    </div>
                </div>
            <div class="projects">
                <h2>Projects</h2>
                <div class="project" v-for="(project,i) in projects.slice(0,4)">
                    <div class="title">
                        <div class="first-row">
                            <img src="../assets/icons/v__icon.svg">
                            <div class="headers">
                                <label>Project Name Here</label>
                                <span>{{project.name | validate }}</span>
                                <span>{{project.company.name | validate }}</span>
                            </div>
                        </div>
                        <div class="second-row">
                            <div class="location">
                                <span>Location</span>
                                <label>{{project.loc | validate }}</label>
                            </div>
                            <div class="time">
                                <span>Time Frame</span>
                                <label>{{project.from +"-"+project.to | validate }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="body-content">
                        <span>Competence</span>
                        <template v-for="(skill,i) in project.skills">
                            <p v-for="(competence) in skill.competences">{{competence.name | validate }}<span v-if="i !== project.skills.length -1">,</span></p>
                        </template>
                        <span>Description</span>
                        <p v-html="project.description"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="__wrapper second">
            <div class="__head">
                <div class="person-card">
                    <img :src="$fullUrl('images/profiles/'+user.profile)">
                    <div class="info-text">
                        <h2>{{user.names | validate }}</h2>
                        <span>{{user.job | validate }}</span>
                    </div>
                </div>
            </div>
            <div class="skills">
                <h2>Skills</h2>
                <div class="skills_content__wrapper">
                    <div class="skill_box">
                        <label>Tools</label>
                        <div class="row__item" v-for="(tool, i) in personalSkills.tools.slice(0,5)">
                            <span>{{tool.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true"  active-color="#1BA5A4" star-size="14" :show-rating="false" v-model="tool.priority"></star-rating>
                        </div>
                    </div>
                    <div class="skill_box">
                        <label>Domain</label>
                        <div class="row__item" v-for="(tool, i) in personalSkills.domains.slice(0,5)">
                            <span>{{tool.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true"  active-color="#1BA5A4" star-size="14" :show-rating="false" v-model="tool.priority"></star-rating>
                        </div>
                    </div>
                    <div class="skill_box">
                        <label>Competence</label>
                        <div class="row__item" v-for="(tool, i) in personalSkills.competences.slice(0,5)">
                            <span>{{tool.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true"  active-color="#1BA5A4" star-size="14" :show-rating="false" v-model="tool.priority"></star-rating>
                        </div>
                    </div>
                </div>
                <div class="skills_content__wrapper skills_content__wrapper-2">
                    <div class="skill_box">
                        <label>Roles</label>
                        <div class="row__item" v-for="(tool, i) in personalSkills.roles.slice(0,5)">
                            <span>{{tool.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true"  active-color="#1BA5A4" star-size="14" :show-rating="false" v-model="tool.priority"></star-rating>
                        </div>
                    </div>
                    <div class="skill_box">
                        <label>Languages</label>
                        <div class="row__item" v-for="(tool, i) in personalSkills.languages.slice(0,5)">
                            <span>{{tool.lang.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true"  active-color="#1BA5A4" star-size="14" :show-rating="false" v-model="tool.level"></star-rating>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="__wrapper second">
            <div class="__head">
                <div class="person-card">
                    <img :src="$fullUrl('images/profiles/'+user.profile)">
                    <div class="info-text">
                        <h2>{{user.names | validate }}</h2>
                        <span>{{user.job | validate }}</span>
                    </div>
                </div>
            </div>
            <div class="projects">
                <h2>Employments</h2>
                <div class="project" v-for="(project,i) in employments.slice(0,4)">
                    <div class="title">
                        <div class="first-row">
                            <img src="../assets/icons/v__icon.svg">
                            <div class="headers">
                                <label>Role</label>
                                <span>{{project.role | validate }}</span>
                                <span>{{project.company.name | validate }}</span>
                            </div>
                        </div>
                        <div class="second-row">
                            <div class="location">
                                <span>Location</span>
                                <label>{{project.loc | validate }}</label>
                            </div>
                            <div class="time">
                                <span>Time Frame</span>
                                <label>{{project.from +"-"+project.to | validate }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="body-content">
                        <span>Competence</span>
                        <template v-for="(skill,i) in project.skills">
                            <p v-for="(competence) in skill.competences">{{competence.name | validate }}<span v-if="i !== project.skills.length -1">,</span></p>
                        </template>
                        <span>Description</span>
                        <p v-html="project.description"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters } from "vuex";
    import { eventBus } from "../main";
    export default {
        name: "CvPage",
        computed :{
            ...mapGetters([
                "getProfile",
            ]),
            user(){
                let job = ''
                let country = ''
                let city = ""
                let role = ""
                if (this.getProfile.employment.length > 0){
                    job = this.getProfile.employment[0].company.name
                    this.getProfile.employment[0].skills.forEach(skill=>{
                        skill.roles.forEach(r=>{
                            if (r.name !== "")
                                role = r.name
                        })
                    })
                }
                if (this.getProfile.profile.location){
                    if (this.getProfile.profile.location.country_id)
                        country = this.getProfile.profile.location.country.name
                    if (this.getProfile.profile.location.city_id)
                        city = this.getProfile.profile.location.city.name
                }


                return {
                    profile : this.getProfile.user.profile_picture,
                    names : this.getProfile.user.first_name + " "+this.getProfile.user.last_name,
                    email : this.getProfile.user.email,
                    phone : this.getProfile.profile.phone,
                    city : city,
                    country : country,
                    location : country + (city===''?'':','+city),
                    available : this.getProfile.profile.availability === 1 ? "Available From" :this.getProfile.profile.availability === 0 ? "Not Available From": "",
                    available_from : this.getProfile.profile.available_from,
                    job : job,
                    description : this.getProfile.profile.description,
                    role : role
                }
            },
            projects(){
                let location = {country : {}, city : {}, address : ''}
                let loc = ""
                return this.getProfile.projects.map(function (item, index) {
                    if (!item.company)
                        eventBus.$set(item, 'company', {});
                    if (!item.location){
                        eventBus.$set(item, 'loc', loc);
                        eventBus.$set(item, 'location', {country : {}, city : {},address : '', id : 0});
                    }
                    else{
                        if (item.location.country_id !== 0 && item.location.country_id !== null)
                            loc = item.location.country.name
                        if (item.location.city_id !== 0 && item.location.city_id !== null)
                            loc += "," + item.location.city.name
                        eventBus.$set(item, 'loc', loc);
                    }
                    if (index === 0)
                        eventBus.$set(item, 'collapse', false);
                    else
                        eventBus.$set(item, 'collapse', true);
                    //
                    eventBus.$set(item, 'editMode', false);
                    eventBus.$set(item, 'skillsCollapsed', true);
                    eventBus.$set(item, 'membersCollapsed', true);
                    return item;
                })
            },
            employments(){
                let location = {country : {}, city : {}, address : '', id : 0}
                let loc = ""
                return this.getProfile.employment.map(function (item, index) {
                    if (!item.company)
                        eventBus.$set(item, 'company', {});

                    if (!item.location){
                        eventBus.$set(item, 'loc', loc);
                        eventBus.$set(item, 'location', {country : {}, city : {},address : '', id : 0});
                    }
                    else{
                        if (item.location.country_id !== 0 && item.location.country_id !== null)
                            loc = item.location.country.name
                        if (item.location.city_id !== 0 && item.location.city_id !== null)
                            loc += "," + item.location.city.name
                        eventBus.$set(item, 'loc', loc);
                    }

                    if (index === 0)
                        eventBus.$set(item, 'collapse', false);
                    else
                        eventBus.$set(item, 'collapse', true);

                    eventBus.$set(item, 'editMode', false);
                    eventBus.$set(item, 'skillsCollapsed', true);
                    eventBus.$set(item, 'membersCollapsed', true);

                    let role = 'no title'

                    item.skills.forEach((skill)=>{
                        skill.roles.forEach((item)=>{
                            role = item.name
                        })
                    })

                    eventBus.$set(item, 'role', role);

                    return item;
                })
            },
            personalSkills(){
                let skills = {tools : [], domains : [], languages : [], competences : [], roles : []}
                this.getProfile.skills.forEach(skill=>{
                    skills.tools = skills.tools.concat(skill.tools)
                    skills.domains = skills.domains.concat(skill.domains)
                    skills.languages = skills.languages.concat(skill.languages)
                    skills.competences = skills.competences.concat(skill.competences)
                    skills.roles = skills.roles.concat(skill.roles)
                })
                return skills
            },
            educations(){
                return  this.getProfile.educations.map(function (item, index) {
                    let loc = 'unset'
                    let location = {id :0, country :{id :0},city :{id :0}, address : ''}
                    if (item.location){
                        if (item.location.country)
                            loc = item.location.country.name
                        if (item.location.city)
                            loc +=',', item.location.city.name
                        if (item.location.address)
                            loc +=',', item.location.address
                    }
                    else
                        item.location = location

                    eventBus.$set(item, 'loc', loc);
                    return item;
                })
            },
        },
        methods : {
            getCV(element, filename = ''){
                var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
                var postHtml = "</body></html>";
                var html = preHtml+document.getElementById(element).innerHTML+postHtml;
                console.log(html)
                var blob = new Blob(['\ufeff', html], {
                    type: 'application/msword'
                });
                
                // Specify link url
                var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
                
                // Specify file name
                filename = filename?filename+'.doc':'document.doc';
                
                // Create download link element
                var downloadLink = document.createElement("a");

                document.body.appendChild(downloadLink);
                
                if(navigator.msSaveOrOpenBlob ){
                    navigator.msSaveOrOpenBlob(blob, filename);
                }else{
                    // Create a link to the file
                    downloadLink.href = url;
                    
                    // Setting the file name
                    downloadLink.download = filename;
                    
                    //triggering the function
                    downloadLink.click();
                }
                
                document.body.removeChild(downloadLink);
                        }
        },
        mounted() {
            this.$store.dispatch("GET_ME_PROFILE",{id : this.$route.params.id})
            // this.getCV('wrp', 'main')
        }
    }
</script>

<style scoped lang="scss">
    .contr{
        display: flex;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        flex-direction: column;
        .__wrapper{
            background: #FFF;
            display: grid;
            min-height: 100%;
            width: 100%;
            grid-template-rows: 1fr 1fr;
            .half{
                .__head{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 145px;
                        height: 145px;
                        border-radius: 100%;
                    }
                   h2{
                       font-size: 28px;
                       font-weight: bolder;
                       color: #FFF;
                       margin-bottom: 0;
                   }
                   span{
                       font-size: 19px;
                       color: #FFF;
                   }
                }
                .profile-box{
                    padding-bottom: 0!important;
                    .right-box{
                        display: flex;
                        flex-direction: column;
                        padding: 20px;
                        justify-content: center;
                        align-items: center;
                        color: #3C4253;
                        font-size: 15px;
                        .cover-letter{
                            margin-top: 10px;
                            p{
                                color: #3C4253;
                                margin-top: 35px;
                                text-align: center;
                                line-height: 21px;
                                font-weight: normal;
                                font-size: 15px;
                            }
                        }
                        img{
                            align-self: flex-end;
                            cursor: pointer;
                        }
                        .__infos{
                            display: flex;
                            line-height: 10px;
                            margin-top: 10px;
                            span{
                                margin-right: 10px;
                                color: #3C4253;
                                font-size: 15px;
                            }
                        }
                        .__availability{
                            margin-top: 10px;
                            color: #3C4253;
                            font-size: 15px;
                        }
                    }
            }
            }
            .first{
                background-image: url("../assets/images/backgrounds/bgbi.svg");
                background-size: cover;
            }
    }
        .second{
            display: flex;
            padding-top: 50px;
            flex-direction: column;
            .__head{
                height: 90px;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-bottom: 20px;
                margin-bottom: 20px;
                background-image: url("../assets/images/backgrounds/cool.svg");
                background-size: cover;
                .person-card{
                    display: flex;
                    align-self: center;
                    margin-top: 20px;
                    color: #FFF;
                    img{
                        width: 40px;
                        height: 40px;
                        border-radius: 100%;
                    }
                    .info-text{
                        margin-left: 10px;
                        display: inline-block;
                        h2{
                            font-size: 20px;
                            font-weight: bolder!important;
                            margin-bottom: 0;
                        }
                        span{
                            font-size: 15px;
                        }
                    }
                }
                @media (min-width: 300px) and (max-width: 630px) {
                    display: none;
                }
            }
            .projects{
                width: 90%;
                margin: 0 auto;
                h2{
                    color: #1BA5A4;
                    font-weight: normal;
                    margin-bottom: 20px;
                    font-size: 13px;
                    margin-left: 20px;
                }
                .project{
                    padding: 20px;
                    border-radius: 5px;
                    background :#F5F5F5;
                    margin-bottom: 20px;
                    .title{
                        display: flex;
                        justify-content: space-between;
                        .first-row{
                            display: flex;
                            img{
                                width: 50px;
                                border-radius: 100%;
                                height: 50px;
                            }
                            .headers{
                                display: flex;
                                margin-left: 20px;
                                flex-direction: column;
                                label{
                                    color: #031019;
                                    margin-bottom: 5px;
                                    font-size: 14px;
                                }
                                span{
                                    color: #646262;
                                    margin-bottom: 5px;
                                    font-size: 13px;
                                }
                            }
                        }
                        .second-row{
                            display: flex;
                            .location,.time{
                                display: flex;
                                padding-top: 5px;
                                padding-bottom: 0!important;
                                flex-direction: column;
                                label{
                                    color: #031019;
                                    margin-bottom: 0;
                                    font-size: 14px;
                                }
                                span{
                                    color: #646262;
                                    margin-bottom: 5px;
                                    font-size: 13px;
                                }
                            }
                            .location{
                                margin-right: 20px;
                                padding-bottom: 0;
                                padding-right: 20px;
                                border-right: 0.5px solid #707070;
                            }
                        }
                    }
                    .body-content{
                        display: flex;
                        padding-top: 20px;
                        flex-direction: column;
                        span{
                            color: #6E6E6E;
                            font-size: 12px;
                        }
                        p{
                            color: #000000;
                            font-size: 12px;
                            margin-bottom: 5px;
                        }
                    }
                }
            }
            .skills{
                width: 90%;
                margin: 0 auto;
                h2{
                    color: #1BA5A4;
                    font-weight: normal;
                    margin-bottom: 20px;
                    font-size: 13px;
                    margin-left: 20px;
                }
                .skills_content__wrapper{
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    grid-gap: 10px;
                    .skill_box{
                        padding: 5px 10px;
                        min-width: 0;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        background: #F5F5F5;
                        border-radius: 5px;
                        label{
                            color: #0884AF;
                            width: 100%;
                            padding-bottom: 10px;
                            font-size: 15px;
                            border-bottom: 0.4px solid #707070;

                        }
                        .row__item{
                            margin-top: 10px;
                            display: flex;
                            margin-bottom: 10px;
                            justify-content: space-between;
                            width: 100%;
                            span{
                                color: #000000;
                                font-weight: normal;
                                margin-top: 2px;
                                font-size: 14px;
                            }
                        }
                    }
                }
                .skills_content__wrapper-2{
                    display: grid;
                    margin-top: 10px;
                    grid-template-columns: 1fr 1fr;
                    grid-gap: 10px;
                }
            }
        }
    }

</style>